<div class="separator {{ size }}"></div>
